module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-music-player"]
  }, [_c('div', {
    staticClass: ["play-top"]
  }, [(_vm._theme !== 'colmo') ? _c('image', {
    staticClass: ["top-img"],
    attrs: {
      "src": _vm.moveImg
    }
  }) : (_vm._theme == 'colmo') ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4790',
      "size": "50",
      "color": "rgba(255,255,255,0.8)"
    }
  }) : _vm._e(), _c('div', {
    ref: "topTitle",
    staticClass: ["top-title"]
  }, [(_vm.marqueeShowFlag) ? _c('dof-marquee', {
    attrs: {
      "width": _vm.marqueeWidth,
      "textWidth": _vm.marqueeTextWidth,
      "height": "44px",
      "text": _vm.marqueeText,
      "bgColor": _vm.themeStyle.marqueeBgColor,
      "textColor": _vm.themeStyle.marqueeTextColor,
      "duration": 10000,
      "delay": 3000
    }
  }) : _c('text', {
    staticClass: ["top-title-text"]
  }, [_vm._v(_vm._s(_vm.playText) + ": " + _vm._s(_vm.title))])], 1), (_vm._theme !== 'colmo') ? _c('div', {
    staticClass: ["top-right"]
  }, [(_vm.play) ? _c('image', {
    staticClass: ["top-img", "top-img-play"],
    attrs: {
      "src": _vm.playImg
    },
    on: {
      "click": function($event) {
        _vm.playHandler('pause')
      }
    }
  }) : _vm._e(), (!_vm.play) ? _c('image', {
    staticClass: ["top-img", "top-img-play"],
    attrs: {
      "src": _vm.pauseImg
    },
    on: {
      "click": function($event) {
        _vm.playHandler('play')
      }
    }
  }) : _vm._e(), _c('image', {
    staticClass: ["top-img"],
    attrs: {
      "src": _vm.nextImg
    },
    on: {
      "click": _vm.nextHandler
    }
  })]) : (_vm._theme == 'colmo') ? _c('div', {
    staticClass: ["top-right"]
  }, [(_vm.play) ? _c('dof-iconfont', {
    staticClass: ["top-img-play"],
    attrs: {
      "code": '\u4773',
      "size": "50",
      "color": "rgba(255,255,255,0.8)"
    },
    on: {
      "dofIconFontClicked": function($event) {
        _vm.playHandler('pause')
      }
    }
  }) : _vm._e(), (!_vm.play) ? _c('dof-iconfont', {
    staticClass: ["top-img-play"],
    attrs: {
      "code": '\u4770',
      "color": "rgba(255,255,255,0.8)",
      "size": "50"
    },
    on: {
      "dofIconFontClicked": function($event) {
        _vm.playHandler('play')
      }
    }
  }) : _vm._e(), _c('dof-iconfont', {
    attrs: {
      "code": '\u4765',
      "size": "50",
      "color": "rgba(255,255,255,0.8)"
    },
    on: {
      "dofIconFontClicked": _vm.nextHandler
    }
  })], 1) : _vm._e()], 1), _c('text', {
    ref: "titleLen",
    staticClass: ["top-title-text", "title-hidden"]
  }, [_vm._v(_vm._s(_vm.playText) + ": " + _vm._s(_vm.title))]), _c('div', {
    staticClass: ["volume-content"]
  }, [(_vm._theme !== 'colmo') ? _c('image', {
    staticClass: ["top-img", "volume-img", "volume-img-left"],
    attrs: {
      "src": _vm.volumeLowImg
    }
  }) : (_vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: ["volume-img", "volume-img-left"],
    attrs: {
      "code": '\u4763',
      "size": "64",
      "color": "rgba(255,255,255,0.8)"
    }
  }) : _vm._e(), _c('dof-slider', {
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "theme": _vm.theme,
      "trackHeight": _vm._trackHeight,
      "trackColor": _vm.trackColor,
      "barColor": _vm.barColor,
      "buttonSize": _vm._buttonSize,
      "buttonColor": _vm.buttonColor,
      "readonly": _vm.readonly,
      "step": _vm.step,
      "gradientBarConfig": _vm._gradientBarConfig
    },
    on: {
      "change": _vm.sliderChangeHandler
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  }), (_vm._theme !== 'colmo') ? _c('image', {
    staticClass: ["top-img", "volume-img", "volume-img-right"],
    attrs: {
      "src": _vm.volumeHighImg
    }
  }) : (_vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: ["volume-img", "volume-img-right"],
    attrs: {
      "code": '\u4791',
      "size": "64",
      "color": "rgba(255,255,255,0.8)"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-1451a23c!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-music-player/index.vue
// module id = 570
// module chunks = 0 1